import React from 'react';
import Link from 'gatsby-link';

import config from '../utils/config';
import { Carousel } from 'react-responsive-carousel';
const Home = () => (
  <div>
    
    <span
      style={{
        fontFamily: "'Euphoria Script', cursive",
        fontSize: '80px',
        fontWeight: 'bold',
        color: config.site.textColor,
        lineHeight: '1em',
      }}>
      {config.personalInfo.bride + ' & ' + config.personalInfo.groom}
    </span>
    <Carousel showThumbs={false}>
		<div>
            <img src={config.img.couplePic} alt={config.personalInfo.couple} />
        </div>
		<div>
            <img src={config.img.couple2} alt={config.personalInfo.couple} style={{maxHeight:600, width:'auto'}}/>
        </div>
		<div>
            <img src={config.img.couple3} alt={config.personalInfo.couple} style={{maxHeight:600, width:'auto'}}/>
        </div>
		<div>
            <img src={config.img.couple4} alt={config.personalInfo.couple} style={{maxHeight:600, width:'auto'}}/>
        </div>
		<div>
            <img src={config.img.couple5} alt={config.personalInfo.couple} style={{maxHeight:600, width:'auto'}}/>
        </div>
	</Carousel>
    <br />
    <p
      style={{
        fontWeight: 'bold',
        fontFamily: "'Dancing Script', cursive",
        fontSize: '25px',
        color: config.site.textColor,
      }}>
      {config.wedding.prettyDate}
    </p>
    <p
      style={{
        fontWeight: 'bold',
        fontSize: '25px',
        fontFamily: "'Dancing Script', cursive",
        color: config.site.textColor,
      }}>
      {config.wedding.location}
    </p>
    
    
  </div>
);

export default Home;



// WEBPACK FOOTER //
// ./src/components/Home.jsx